import script from "./SettleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SettleTab.vue?vue&type=script&setup=true&lang=js"

import "./SettleTab.vue?vue&type=style&index=0&id=1a9ad997&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9ad997"]])

export default __exports__